export function getUpdatedSearchParams<
  T extends object = Record<string, string | number | boolean | null>,
>(params: T) {
  if (typeof window !== "undefined" && "URLSearchParams" in window) {
    const searchParams = new URLSearchParams(window.location.search);

    Object.keys(params).forEach((key) => {
      if (params.hasOwnProperty(key)) {
        const value = params[key as keyof T];
        if (!value) {
          searchParams.delete(key);
        } else {
          searchParams.set(key, value.toString());
        }
      }
    });

    return searchParams.toString();
  }

  return "";
}

export function getSearchParams(): URLSearchParams | null {
  if (typeof window !== "undefined" && "URLSearchParams" in window) {
    return new URLSearchParams(window.location.search);
  } else {
    return null;
  }
}

export function getUpdatedSearchParamsUrl<
  T extends object = Record<string, string | number | boolean | null>,
>(params: T, url?: string) {
  const newParams = getUpdatedSearchParams(params);
  if (url) {
    return [url, newParams].filter(Boolean).join("?");
  } else if (typeof window !== "undefined") {
    return [`${window.location.origin}${window.location.pathname}`, newParams]
      .filter(Boolean)
      .join("?");
  } else {
    return "";
  }
}
